import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Font } from 'mm-theme-configuration';
import { WebFontsComponentProps } from '../../theming/ThemeProviderWithFonts';
import { getStylesheetByProvider } from './webFonts.utils';
import { WebfontLoader } from './webfontLoader';

interface LinkProps {
    fontConfiguration:Font
}

const FontLink:React.FunctionComponent<LinkProps> = ({ fontConfiguration }) => {
  const [rel, setRel] = React.useState('preload');
  React.useEffect(() => {
    setRel('stylesheet');
  }, []);

  return (
    <Helmet>
      <link rel={rel} href={getStylesheetByProvider(fontConfiguration)} as="style" />
    </Helmet>
  );
};

/* eslint-disable-next-line jsx-a11y/anchor-is-valid */
const createFontFamilyLink = (fontConfiguration: Font, index: number) => <FontLink fontConfiguration={fontConfiguration} key={index} />;

const DEFAULT_FONT_FAMILY_CLASS_NAME = 'default-font-family';
const FONT_FAMILY_CLASS_NAME = 'font-family';

export const WebFonts: React.FunctionComponent<WebFontsComponentProps> = props => {
  const { fontsConfiguration, fontFamilyByElement, children } = props;
  const [className, setClassName] = React.useState(DEFAULT_FONT_FAMILY_CLASS_NAME);

  React.useEffect(() => {
    new WebfontLoader(fontsConfiguration).observeFontLoading().then(() => setClassName(FONT_FAMILY_CLASS_NAME));
  }, [fontsConfiguration]);

  return (
    <React.Fragment>
      <Helmet>
        {/* eslint-disable-next-line jsx-a11y/html-has-lang */}
        <html className={className} />
      </Helmet>
      {fontsConfiguration.map(createFontFamilyLink)}
      {/* eslint-disable-next-line react/no-danger */}
      <style dangerouslySetInnerHTML={{
        __html: `
.${DEFAULT_FONT_FAMILY_CLASS_NAME} h1 { font-family: ${fontFamilyByElement.h1.defaultFontFamily}; }
.${DEFAULT_FONT_FAMILY_CLASS_NAME} h2 { font-family: ${fontFamilyByElement.h2.defaultFontFamily}; }
.${DEFAULT_FONT_FAMILY_CLASS_NAME} h3 { font-family: ${fontFamilyByElement.h3.defaultFontFamily}; }
.${DEFAULT_FONT_FAMILY_CLASS_NAME} h4 { font-family: ${fontFamilyByElement.h4.defaultFontFamily}; }
.${DEFAULT_FONT_FAMILY_CLASS_NAME} span { font-family: ${fontFamilyByElement.span.defaultFontFamily}; }
.${DEFAULT_FONT_FAMILY_CLASS_NAME} p { font-family: ${fontFamilyByElement.p.defaultFontFamily}; }
.${DEFAULT_FONT_FAMILY_CLASS_NAME} { font-family: ${fontFamilyByElement.p.defaultFontFamily}; }
.${FONT_FAMILY_CLASS_NAME} h1 { font-family: ${fontFamilyByElement.h1.fontFamily}, ${fontFamilyByElement.h1.defaultFontFamily};}
.${FONT_FAMILY_CLASS_NAME} h2 { font-family: ${fontFamilyByElement.h2.fontFamily}, ${fontFamilyByElement.h2.defaultFontFamily}; }
.${FONT_FAMILY_CLASS_NAME} h3 { font-family: ${fontFamilyByElement.h3.fontFamily}, ${fontFamilyByElement.h3.defaultFontFamily}; }
.${FONT_FAMILY_CLASS_NAME} h4 { font-family: ${fontFamilyByElement.h4.fontFamily}, ${fontFamilyByElement.h4.defaultFontFamily}; }
.${FONT_FAMILY_CLASS_NAME} span { font-family: ${fontFamilyByElement.span.fontFamily}, ${fontFamilyByElement.span.defaultFontFamily}; }
.${FONT_FAMILY_CLASS_NAME} p { font-family: ${fontFamilyByElement.p.fontFamily}, ${fontFamilyByElement.p.defaultFontFamily}; }
.${FONT_FAMILY_CLASS_NAME} { font-family: ${fontFamilyByElement.p.fontFamily}, ${fontFamilyByElement.p.defaultFontFamily}; }`,
      }}
      />
      {children}
    </React.Fragment>
  );
};
